/**
 * Reset a form after by clicking on reset button.
 */
const $ = window.jQuery;

export default {
  attach: function (context, settings) {
    let $newContent = $(context);
    let $submissionForm = $newContent.find('form.webform-submission-form');

    if ($submissionForm.length > 0) {
      $submissionForm.each(function (index, item){
        let $item = $(item);

        // Calling a function to set an event listener.
        Drupal.behaviors.formReset.setEventListener($item);
      });
    };
  },
  /**
   * Set click event listener on submission form and reset fields.
   * @param $form
   */
  setEventListener: function ($form) {
    let $resetButton = $form.find('.form-actions .reset-form a');

    /**
     * Reset custom made select elements.
     * @param $selects
     */
    function resetSelectElement($selects) {
      $selects.each(function(index, select){
        let $select = $(select);
        let $wrapper = $select.find('.select-wrapper');
        let $realSelect = $wrapper.find('select');
        let $label = $wrapper.find('.selectric .label');
        let $firstSelect = $realSelect.find('option:first');

        // Update options and set the right label.
        $label.text($firstSelect.text());
        $realSelect
          .find('option:selected')
          .removeAttr('selected');
        $firstSelect.attr('selected', 'selected');
      });
    }

    if ($resetButton.length > 0) {
      let $selectElements = $form.find('.form-type-select');

      // Unbind all events on button.
      $resetButton.unbind();

      $resetButton.on('click', function(){
        if ($selectElements.length > 0) {
          resetSelectElement($selectElements);
        };

        // Reset all other form elements.
        $form[0].reset();
      });

    };
  },
}
